// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"139":"84a4ff09","206":"c3bd6b99","443":"089fd9dc","829":"37e1f7ba"}[chunkId] + ".css";
};